import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SelectGroup from './select-group';
import InputGroup from './input-group';
import ToggleGroup from './toggle-group';
import CheckboxGroup from './checkbox-group';
import { hours, minutes, ampm as AMPM } from '../../util';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps != this.props) {
            return true;
        }

        return false;
    }

    /* eslint-disable max-len */
    render({ name, label, time, hour, minute, ampm, onChange, disabled }) {
        return (
            <birth-time-group>
                <row className='is-wrap'>
                    <column className='is-5 is-visible-desktop'>
                        <row>
                            <column className='is-4 is-visible-desktop has-padding-10-right'>
                                <SelectGroup
                                    name={`${name}_hour`}
                                    label={label}
                                    value={hour.value}
                                    disabled={time.value == 'unknown' || disabled}
                                    placeholder='HOUR'
                                    options={hours}
                                    error={hour.error}
                                    onChange={onChange}
                                />
                            </column>
                            <column className='is-4 is-visible-desktop has-padding-10-right'>
                                <SelectGroup
                                    name={`${name}_minute`}
                                    label='&nbsp;'
                                    value={minute.value}
                                    disabled={time.value == 'unknown' || disabled}
                                    placeholder='MINUTE'
                                    options={minutes}
                                    error={minute.error}
                                    onChange={onChange}
                                />
                            </column>
                            <column className='is-4 is-visible-desktop has-padding-10-right'>
                                <ToggleGroup
                                    options={AMPM}
                                    value={ampm.value}
                                    name={`${name}_ampm`}
                                    onChange={onChange}
                                    disabled={time.value == 'unknown' || disabled}
                                />
                            </column>
                        </row>
                    </column>
                    <column className='is-hidden-desktop is-4-tablet is-6-mobile has-padding-10-right'>
                        <InputGroup
                            type='time'
                            name={name}
                            label={label}
                            placeholder='SELECT TIME'
                            value={time.value}
                            disabled={time.value == 'unknown' || disabled}
                            error={time.error}
                            onInput={onChange}
                        />
                    </column>
                    <column className='is-7-desktop is-8-tablet is-6-mobile has-padding-10-top-desktop has-padding-10-top-tablet'>
                        <CheckboxGroup
                            name='birth_time'
                            value='unknown'
                            label={'<small><b>I don\'t know my birth time</b><br />(this is used to calculate your rising and moon signs)</small>'}
                            checked={time.value == 'unknown'}
                            onChange={onChange}
                            disabled={disabled}
                        />
                    </column>
                </row>
            </birth-time-group>
        );
    }
    /* eslint-enable max-len */
}

export default connect()(Component);
